import React from 'react';
import { Accordion, AccordionItem } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { renderScoreChip } from './claimScoreRendererShared';

export interface StopGateItem {
    key: string;
    label: string;
    score?: unknown;
}

export interface StopGatesSectionProps {
    items: StopGateItem[];
    activeKey: string | null;
    onItemClick: (key: string) => void;
}

const StopGatesTitle: React.FC<{ count: number }> = ({ count }) => (
    <div className="flex items-center gap-2">
        <span
            className="flex items-center justify-center rounded-full bg-danger text-white text-[11px] font-semibold flex-shrink-0"
            style={{ width: '22px', height: '22px' }}
        >
            {String(count).padStart(2, '0')}
        </span>
        <span className="text-danger font-medium text-[14px]">Stop gates</span>
        <Icon
            icon="mdi:chevron-right"
            className="text-danger w-4 h-4 transition-transform group-aria-expanded:rotate-90"
        />
    </div>
);

export const StopGatesSection: React.FC<StopGatesSectionProps> = ({ items, activeKey, onItemClick }) => {
    if (items.length === 0) return null;

    return (
        <div className="mb-2">
            <Accordion
                variant="light"
                isCompact
                selectionMode="multiple"
                className="p-0 [&_hr]:hidden [&_.divider]:hidden"
            >
                <AccordionItem
                    key="stop-gates"
                    aria-label="Stop gates"
                    title={<StopGatesTitle count={items.length} />}
                    indicator={<></>}
                    classNames={{
                        base: 'w-full !border-none !shadow-none !bg-transparent !px-0',
                        trigger: 'group py-1 px-0',
                        content: 'pb-1 pt-1 pl-0 pr-0',
                    }}
                >
                    <div className="divide-y divide-default-200">
                        {items.map((item) => {
                            const isActive = activeKey === item.key;
                            return (
                                <button
                                    key={item.key}
                                    type="button"
                                    onClick={() => onItemClick(item.key)}
                                    className={`w-full flex items-center justify-between gap-2 py-2 px-1 text-left rounded-md transition-colors ${
                                        isActive ? 'bg-danger/10 hover:bg-danger/20' : 'hover:bg-default-100'
                                    }`}
                                >
                                    <span className="flex items-center gap-2 min-w-0">
                                        <Icon icon="mdi:close-circle" className="text-danger w-4 h-4 flex-shrink-0" />
                                        <span className="text-foreground text-[14px] truncate">{item.label}</span>
                                    </span>
                                    <span className="flex-shrink-0">{renderScoreChip(item.score)}</span>
                                </button>
                            );
                        })}
                    </div>
                </AccordionItem>
            </Accordion>
        </div>
    );
};
